// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"540":"8ea6db09","917":"c344f305"}[chunkId] + ".chunk.js";
};